import { render, staticRenderFns } from "./KreirajLiguField.vue?vue&type=template&id=56234448&scoped=true&"
import script from "./KreirajLiguField.vue?vue&type=script&lang=js&"
export * from "./KreirajLiguField.vue?vue&type=script&lang=js&"
import style0 from "./KreirajLiguField.vue?vue&type=style&index=0&id=56234448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56234448",
  null
  
)

export default component.exports